<template>
  <i-modal
    class="add-question-product-code-modal"
    :value="show"
    fullscreen
    footer-hide
    title="按型号组题"
    @on-visible-change="modalShowStateChanged">
    <add-question-by-product-code-step :current="currentStep" />

    <!-- 这里的v-if用来触发重置步骤组件 -->
    <div v-if="show" class="step-item">
      <keep-alive exclude="AddQuestionByProductCodes">
        <component
          :is="stepComponent"
          :filter-menu="filterMenu"
          :product-codes="productCodes"
          :questions="productCodeQuestions" />
      </keep-alive>

          <!-- :question-count="questionCount"
          :group-count="groupCount"
          @disabled-done-btn="disabledDoneBtnHandler"  -->
    </div>

    <add-question-action-bar
      :steps="3"
      :current="currentStep"
      :type="type"
      :done-btn-enable="true"
      @canel="canelAddQuestionHandler"
      @prev="prevStepHandler"
      @next="nextStepHandler"
      @done="doneStepHandler" />
  </i-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddQuestionByProductCodeStep from './AddQuestionByProductCodeStep.vue';
import AddQuestionActionBar from './AddQuestionActionBar.vue';
import TestQuestionFilterByProductCode from './TestQuestionFilterByProductCode.vue';
import ProductCodesTransfer from './ProductCodesTransfer.vue';
import AddQuestionByProductCodes from './AddQuestionByProductCodes.vue';

export default {
  name: 'AddQuestionByProductCodeModal',
  components: {
    AddQuestionByProductCodeStep,
    AddQuestionActionBar,
  },
  data() {
    return {
      currentStep: 0,
      stepComponent: TestQuestionFilterByProductCode,
      filterMenu: {},
      productCodes: [],
      productCodeQuestions: [],
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      paperId: 'createPaperStore/paperId',
      type: 'createPaperStore/addQuestionByProductCodeModalType',
      show: 'createPaperStore/addQuestionByProductCodeModalShow',
      addBigQuestionRule: 'createPaperStore/addBigQuestionRule',
    }),
  },
  watch: {
    currentStep(value) {
      switch (value) {
        case 0:
          this.stepComponent = TestQuestionFilterByProductCode;
          break;
        case 1:
          this.stepComponent = ProductCodesTransfer;
          break;
        case 2:
          this.stepComponent = AddQuestionByProductCodes;
          break;
        default:
          break;
      }
    },
    show(state) {
      if (state) {
        this.requestFilterMenuListAndSetting();
      } else {
        this.resetAddBigQuestionRule();
        this.setComQuestionType({ comQuestionType: '' });
        this.setAddQuestionByProductCodeModalType({ type: '' });
      }
    },
  },
  methods: {
    ...mapActions({
      setAddQuestionByProductCodeModalType: 'createPaperStore/invokeSetAddQuestionByProductCodeModalType',
      setAddQuestionByProductCodeModalShow: 'createPaperStore/invokeSetAddQuestionByProductCodeModalShow',
      setComQuestionType: 'createPaperStore/invokeSetComQuestionType',
      resetAddBigQuestionRule: 'createPaperStore/invokeResetAddBigQuestionRule',
      setAddBigQuestionRuleOfProductLibraryTypeList: 'createPaperStore/invokeSetAddBigQuestionRuleOfProductLibraryTypeList',
      setAddBigQuestionRuleOfGroupCodeMap: 'createPaperStore/invokeSetAddBigQuestionRuleOfGroupCodeMap',
      setBigQuestions: 'createPaperStore/invokeSetBigQuestions',
      setAddBigQuestionRuleOfProductCodes: 'createPaperStore/invokeSetAddBigQuestionRuleOfProductCodes',
    }),
    modalShowStateChanged(show) {
      this.setAddQuestionByProductCodeModalShow({ show });

      if (!show) {
        this.currentStep = 0;
      }
    },
    /**
     * 取消添加大类或题目处理函数
     */
    canelAddQuestionHandler() {
      this.setAddQuestionByProductCodeModalShow({ show: false });
    },
    /**
     * 上一步处理函数
     */
    prevStepHandler() {
      if (this.currentStep === 1) {
        this.setAddBigQuestionRuleOfProductCodes({ productCodes: [] });
      }

      if (this.currentStep === 2) {
        this.setAddBigQuestionRuleOfProductLibraryTypeList({ list: [] });
      }

      this.currentStep -= 1;
    },
    nextStepHandler() {
      if (this.currentStep === 0) {
        if (this.addBigQuestionRule.years.length === 0) {
          alert('未选择年份筛选条件');
          return;
        }

        if (this.addBigQuestionRule.levels.length === 0) {
          alert('未选择难易度筛选条件');
          return;
        }

        if (this.addBigQuestionRule.productGroupCodes.length === 0) {
          alert('未选择产品组筛选条件');
          return;
        }

        this.requestProductCodesAndSetting();
      } else if (this.currentStep === 1) {
        if (this.addBigQuestionRule.productCodes.length === 0) {
          alert('未选择产品型号');

          return;
        }

        this.requestQuestionCountAndSetting();
      }

      this.currentStep += 1;
    },
    doneStepHandler() {
      let flag = false;

      const questionListCount = JSON.parse(
        JSON.stringify(this.addBigQuestionRule.productLibraryTypeList),
      );

      questionListCount.forEach((question) => {
        for (let i = 0; i < question.types.length; i++) {
          if (!question.types[i].libraryCount) {
            question.types.splice(i, 1);
            i--;
          }
        }
      });

      for (let i = 0; i < questionListCount.length; i++) {
        if (questionListCount[i].types.length === 0) {
          questionListCount.splice(i, 1);
          i--;
        }
      }

      if (questionListCount.length > 0) flag = true;

      this.setAddBigQuestionRuleOfProductLibraryTypeList({ list: questionListCount });

      if (!flag) {
        alert('未添加选题');
        return;
      }

      if (this.type === 'add') {
        this.requestDoneBigQuestionAndSetting();
      } else if (this.type === 'update') {
        this.requestDoneUpdateQuestionAndSetting();
      }
    },
    /**
     * 请求筛选目录列表并设置
     */
    requestFilterMenuListAndSetting() {
      this.requestFilterMenuList()
        .then((result) => {
          this.filterMenu = result;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求筛选目录列表
     */
    requestFilterMenuList() {
      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryFilterMenu();

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求产品型号并设置
     */
    requestProductCodesAndSetting() {
      this.requestProductCodes()
        .then((data) => {
          if (data && data.length === 0) {
            this.productCodes = [];

            alert('无可选的型号');
            return;
          }

          const productCodes = [];

          data.forEach((product) => {
            productCodes.push({ ...product, key: product.productCode });
          });

          this.productCodes = productCodes;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求产品型号
     */
    requestProductCodes() {
      const params = {
        paperId: this.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years.join(','),
        level: this.addBigQuestionRule.levels.join(','),
        groupCodes: this.addBigQuestionRule.productGroupCodes.join(','),
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateProductCodes(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 获取题目数量并设置
     */
    requestQuestionCountAndSetting() {
      this.requestQuestionCount()
        .then((data) => {
          if (data && data.length === 0) {
            alert('无可选型号');
            return;
          }

          this.productCodeQuestions = data;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 获取题目数量
     */
    requestQuestionCount() {
      const params = {
        paperId: this.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years.join(','),
        level: this.addBigQuestionRule.levels.join(','),
        groupCodes: this.addBigQuestionRule.productGroupCodes.join(','),
        productCodes: this.addBigQuestionRule.productCodes.join(','),
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateQuestionCountByProductCodes(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求完成试题大类组题并设置
     */
    requestDoneBigQuestionAndSetting() {
      this.requestDoneBigQuestion()
        .then((result) => {
          alert('添加题目大类成功');

          this.groupCount = {};
          this.setBigQuestions({ bigQuestions: result.result });
          this.setAddQuestionByProductCodeModalShow({ show: false });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求完成试题大类组题
     */
    requestDoneBigQuestion() {
      const params = {
        isRequiredQuestion: false,
        paperLibraryFlag: 'PRODUCT',
        paperId: this.addBigQuestionRule.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years,
        levels: this.addBigQuestionRule.levels,
        groupCodes: this.addBigQuestionRule.productGroupCodes.join(','),
        productLibraryTypeList: this.addBigQuestionRule.productLibraryTypeList,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateAddBigQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求完成更新大类小题并设置
     */
    requestDoneUpdateQuestionAndSetting() {
      this.requestDoneUpdateQuestion()
        .then((result) => {
          alert('添加题目成功');

          this.setBigQuestions({ bigQuestions: result.result });
          this.setAddQuestionByProductCodeModalShow({ show: false });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求完成更新大类小题
     */
    requestDoneUpdateQuestion() {
      const params = {
        partId: this.addBigQuestionRule.partId,
        paperLibraryFlag: 'PRODUCT',
        paperId: this.addBigQuestionRule.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years,
        levels: this.addBigQuestionRule.levels,
        groupCodes: this.addBigQuestionRule.productGroupCodes.join(','),
        productLibraryTypeList: this.addBigQuestionRule.productLibraryTypeList,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateUpdateBigQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-question-product-code-modal {
  .step-item {
    display: flex;
    justify-content: center;
    margin: 36px 0;
  }
}
</style>
